import { Dropdown, Menu } from 'antd';
import styled from 'styled-components';
export const SpacerMenu = styled(Menu.Item)`
  padding-top: 15px;
  padding-bottom: 15px;
  &:hover {
    background: #ffba00;
    color: #fff;
  }
`;
export const DropdownItem = styled(Dropdown.Button)`
  .ant-btn {
    border-radius: 50% !important;
    border: none;
    width: 30px;
    height: 30px;
    &:hover {
      box-shadow: 2px 2px 8px 2px rgba(0, 0, 0, 0.3);
    }
  }
`;
export const DownloadContainer = styled.div`
  margin-left: 35px;
`;